import React, { useState } from "react";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { GoDot } from "react-icons/go";
import { HiOutlineArrowSmLeft } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../commonComponent/Button";
import ToastBox from "../../commonComponent/ToastBox";
import { createCarePlanService } from "../../services/CreateCarePlanService";
import {
  getUploadFileCategory,
  uploadFile,
} from "../../services/FileUploadService";
import { toastMsg } from "../../Utils/AllConstant";
import {
  getFileName,
  isEmpty,
  showToastSuccess,
  getFileExtinsion,
  showToastError,
  changeDateFormatYYYY,
} from "../../Utils/Helper";
import Navbar from "../header/Navbar";
import Sidebar from "../sidebar/Sidebar";
import DateInput from "../../commonComponent/CutomDatePicker";

let defaultCarePlanDetail = {
  name: "",
  description: "",
  image: "",
};

const CarePlanDescription = (props) => {
  const navigate = useNavigate();
  const [carePlanDetail, setCarePlanDetail] = useState(defaultCarePlanDetail);
  const [toast, setToast] = useState({});
  const [nameError, setNameError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [isLoading, setLoader] = useState(false);
  const [careTitleCreate, setCareTitleCreate] = useState("");
  const [careDescriptionCreate, setCareDescriptionCreate] = useState("");
  const [careDuration, setCareDuration] = useState(0);
  const [assignDateCreate, setAssignDateCreate] = useState("");
  const [error, setError] = useState({
    title: false,
    desc: false,
    duration: false,
    assign_date: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    checkValidation();
  };
  const checkValidation = () => {
    try {
      let errorsResult = error;
      let isValid = true;
      if (!careTitleCreate || isEmpty(careTitleCreate)) {
        isValid = false;
        errorsResult = { ...errorsResult, title: true };
      }
      if (!careDescriptionCreate || isEmpty(careDescriptionCreate)) {
        isValid = false;
        errorsResult = { ...errorsResult, desc: true };
      }
      if (!careDuration || isEmpty(careDuration)) {
        isValid = false;
        errorsResult = { ...errorsResult, duration: true };
      }
      if (!assignDateCreate || isEmpty(assignDateCreate)) {
        isValid = false;
        errorsResult = { ...errorsResult, assign_date: true };
      }
      // if (!endDateCreate || isEmpty(endDateCreate)) {
      //   isValid = false;
      //   errorsResult = { ...errorsResult, end_date: true }
      // }
      // if (!programMembersCreate || isEmpty(programMembersCreate)) {
      //   isValid = false;
      //   errorsResult = { ...errorsResult, members: true }
      // }
      // if (!programCareTeam || isEmpty(programCareTeam)) {
      //   isValid = false;
      //   errorsResult = { ...errorsResult, careTeam: true }
      // }

      setError(errorsResult);
      if (isValid) {
        createCarePlan();
      }
    } catch (error) {}
  };
  const onChangeCarePlanDetail = (key, value) => {
    setCarePlanDetail({ ...carePlanDetail, [key]: value });
  };

  const createCarePlan = async () => {
    var params = {};
    params["name"] = careTitleCreate;
    params["description"] = careDescriptionCreate;
    params["duration"] = Number(careDuration);
    params["assignDate"] =
      assignDateCreate == null ? null : changeDateFormatYYYY(assignDateCreate);
    params["mealPlan"] = "";
    params["formId"] = "";
    params["fitnessPlan"] = "";
    params["affirmations"] = [];
    params["programs"] = [];
    params["medications"] = [];
    params["suppliments"] = [];
    // params["suppliments"] = newcareplanId ? supplimentResult : careSuppliments;
    params["groups"] = [];
    params["clients"] = [];

    const response = await createCarePlanService(params);
    setLoader(false);
    if (response.status === 200) {
      showToastSuccess(`Care Plan is created`);
      // setProgramId(response.data.data.insertedId)
      props.setShowPopup(false);
      navigate("/careplan", {
        state: { componentType: "Add", careplan: response.data },
      });
      props.getCarePlanList();
    } else {
      showToastError(
        response?.data || response.message || "Some error occurred"
      );
    }
  };

  const renderError = (msg, value) => {
    return value ? (
      <h6
        className="text-danger error"
        style={{ marginBottom: 15, marginTop: -28 }}
      >
        {msg}
      </h6>
    ) : null;
  };
  const exceptThisSymbols = ["e", "E", "+", "-", "."];

  return (
    <>
      <form onSubmit={handleSubmit}>
        {/* <Navbar /> */}
        <div>
          <div className="col-md-12">
            {/* <p className="dashboard_title">
                <Link to="" className="link_text">
                  <HiOutlineArrowSmLeft onClick={() => navigate(-1)} className="icon" />
                </Link>
                Care Plans
                <span className="patient_lifestyle2">
                  <GoDot />
                  Description
                </span>
              </p> */}
            <div class="container">
              <div class="row justify-content-start">
                <div className="row mt-4">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                        <p className="whole_label resFont">
                          Care Plan Title
                          <span style={{ color: "red", fontWeight: "bold" }}>
                            {" "}
                            *
                          </span>
                        </p>
                        <input
                          type="text"
                          className="description_inputf"
                          value={careTitleCreate}
                          maxLength={80}
                          onChange={(e) => {
                            setCareTitleCreate(e.target.value);
                            setError({ ...error, title: false });
                          }}
                        />
                        {renderError("Please enter title", error.title)}
                      </div>

                      <div className="col-md-12">
                        <p className="whole_label resFont">
                          description
                          <span style={{ color: "red", fontWeight: "bold" }}>
                            *
                          </span>
                        </p>
                        <textarea
                          rows="6"
                          type="text"
                          className="description_inputf description_descpf is-invalid"
                          value={careDescriptionCreate}
                          maxLength={200}
                          onChange={(e) => {
                            setError({ ...error, desc: false });
                            setCareDescriptionCreate(e.target.value);
                          }}
                        />
                        {renderError("Please enter description", error.desc)}
                      </div>
                      <div className="col-md-6 mb-4">
                        <p className="whole_label resFont">
                          Start Date <span className="small_letter2"></span>{" "}
                          <span style={{ color: "red", fontWeight: "bold" }}>
                            *
                          </span>
                        </p>
                        <DateInput
                          value={assignDateCreate}
                          onChangeDate={(date) => {
                            setAssignDateCreate(date);
                            setError({ ...error, assign_date: false });
                          }}
                          // maxDate={endDateCreate}
                          minDate={new Date()}
                          inputClassName={
                            "description_inputf d-flex mb-0 align-items-center z-3 "
                          }
                        />
                        {error.assign_date ? (
                          <h6
                            className="text-danger error"
                            style={{ marginTop: 7 }}
                          >
                            {"Please select assign date"}
                          </h6>
                        ) : null}
                      </div>
                      <div className="col-md-6 ">
                        <p className="whole_label resFont">
                          Duration (Number of Days)
                          <span className="small_letter2"></span>
                          <span style={{ color: "red", fontWeight: "bold" }}>
                            {" "}
                            *
                          </span>
                        </p>
                        <input
                          type="number"
                          className="description_inputf"
                          value={careDuration}
                          min="0"
                          max="36500"
                          onKeyDown={(e) =>
                            exceptThisSymbols.includes(e.key) &&
                            e.preventDefault()
                          }
                          onChange={(e) => {
                            setCareDuration(e.target.value.slice(0, 5));
                            setError({ ...error, duration: false });
                          }}
                          onWheel={(e) => e.currentTarget.blur()}
                          onTouchMove={(e) => e.currentTarget.blur()}
                        />
                        {/* {renderError('Please enter duration', error.duration)} */}
                        {error.duration ? (
                          <h6
                            className="text-danger error"
                            style={{ marginTop: "-27px" }}
                          >
                            {"Please select Number of days"}
                          </h6>
                        ) : null}
                      </div>
                      <div className="col-md-12">
                        <hr />
                        <div className="d-flex justify-content-between">
                          <div
                            style={{
                              backgroundColor: "#fff",
                              color: "black",
                              border: "1px solid #bbb9b9",
                            }}
                            onClick={() => {
                              props.setShowPopup(false);
                            }}
                            className="description_btnsave pointer d-flex justify-content-center align-items-center"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            Cancel
                          </div>
                          <Button
                            isLoading={isLoading}
                            type="submit"
                            id="jhsv"
                            text={"save"}
                            style={isLoading ? { cursor: "none" } : {}}
                            className="description_btnsave"
                          />
                        </div>
                      </div>
                      <div className="col-md-12"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      {/* <ToastBox toastShow={toast.visible} content={`${toast.msg}`} /> */}
    </>
  );
};

export default CarePlanDescription;
